export default import.meta.ROLLDOWN_FILE_URL_VS8VcCSIW7MLYj6GBLhpww